/** @format */

import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
// import App from './App';
import App from './views';
import * as serviceWorker from './serviceWorker';
import icons from './assets/icons';
import "typeface-roboto";
import './scss/style.scss';

(React as any).icons = icons;

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
